import { create } from "zustand";
import {
  addDays,
  format,
  lastDayOfMonth,
  nextSaturday,
  parseISO,
  previousSaturday,
  previousSunday,
  subDays,
  subMonths,
  subYears,
} from "date-fns";

export const periodByOptions = [
  { value: "Due Date", label: "Due Date" },
  { value: "Settlement Date", label: "Settlement Date" },
  { value: "Competence Date", label: "Competence Date" },
];

const createPeriodOptions = () => [
  { from: new Date(), to: new Date(), label: "Today", compare_from: subDays(new Date(), 1), compare_to: subDays(new Date(), 1) },
  { from: previousSunday(new Date()), to: nextSaturday(new Date()), label: "This week", compare_from: previousSunday(previousSunday(new Date())), compare_to: previousSaturday(new Date()) },
  { from: parseISO(format(new Date(), "yyyy-MM-01")), to: lastDayOfMonth(new Date()), label: "This month", compare_from: subMonths(parseISO(format(new Date(), "yyyy-MM-01")), 1), compare_to: subDays(parseISO(format(new Date(), "yyyy-MM-01")), 1) },
  { from: subMonths(parseISO(format(new Date(), "yyyy-MM-01")), 1), to: subDays(parseISO(format(new Date(), "yyyy-MM-01")), 1), label: "Last month", compare_from: subMonths(parseISO(format(new Date(), "yyyy-MM-01")), 2), compare_to: subDays(subMonths(parseISO(format(new Date(), "yyyy-MM-01")), 1), 1) },
  { from: parseISO(format(new Date(), "yyyy-01-01")), to: parseISO(format(new Date(), "yyyy-12-31")), label: "This year", compare_from: subYears(parseISO(format(new Date(), "yyyy-01-01")), 1), compare_to: subYears(parseISO(format(new Date(), "yyyy-12-31")), 1) },
  { from: subDays(new Date(), 29), to: new Date(), label: "Last 30 days", compare_from: subDays(new Date(), 59), compare_to: subDays(new Date(), 30) },
  { from: addDays(subMonths(new Date(), 12), 1), to: new Date(), label: "Last 12 months", compare_from: addDays(subMonths(new Date(), 24), 1), compare_to: subMonths(new Date(), 12) },
  { from: new Date(), to: new Date(), label: "Custom", compare_from: new Date(), compare_to: new Date() },
];

const useReportsSectionStore = create((set) => {
  const periodOptions = createPeriodOptions();
  const defaultPeriod = periodOptions.find((o) => o.label === "This month");
  return {
    filters: {
      report: "Received",
      period: {
        label: defaultPeriod.label,
        from: defaultPeriod.from,
        to: defaultPeriod.to,
        compare_from: defaultPeriod.compare_from,
        compare_to: defaultPeriod.compare_to,
      },
      period_by: periodByOptions[0],
    },
    chartOfAccountSelected: null,
    setChartOfAccountSelected: (chartOfAccountSelected) => set({ chartOfAccountSelected }),
    periodOptions,
    periodByOptions,
    setFilters: (nextFilters) =>
      set((state) => {
        const prev = state.filters;
        let merged = { ...prev, ...nextFilters };

        const reportChanged = Object.prototype.hasOwnProperty.call(nextFilters, "report") && nextFilters.report !== prev.report;
        if (reportChanged && !Object.prototype.hasOwnProperty.call(nextFilters, "period_by")) {
          const map = {
            Received: "Settlement Date",
            Outstanding: "Competence Date",
            Renegotiated: "Due Date",
            "Vacation Free": "Settlement Date",
          };
          const desired = map[merged.report];
          if (desired) merged.period_by = state.periodByOptions.find((o) => o.label === desired);
        }

        if (reportChanged && merged.report !== "Custom" && merged?.period?.label === "Custom") {
          const fallback = state.periodOptions.find((o) => o.label === "This month") || state.periodOptions[0];
          if (fallback) {
            merged.period = { label: fallback.label, from: fallback.from, to: fallback.to, compare_from: fallback.compare_from, compare_to: fallback.compare_to };
          }
        }
        return { filters: merged };
      }),
  };
});

export default useReportsSectionStore;

